import * as ExcessUtil from 'notebook/tables/excess/Util';
import {BaseTypedValueType, CustomEvalResult, TypedValue} from 'notebook/tables/TableConstants';
import {isTypedValueEmpty} from 'notebook/tables/typed-values/DataTypes';

const PURITY_RANGE_ERROR = 'Purity must be a number between 0 and 100%.';

export function getMoleculePurityColumnCustomEval(typedValue: TypedValue): CustomEvalResult {
  // make sure there is a value and it is between 0 and 100
  if (
    isTypedValueEmpty(typedValue) ||
    typedValue.type !== BaseTypedValueType.NUMBER ||
    typedValue.rawValue <= 0 ||
    typedValue.rawValue > 100
  ) {
    return {
      val: typedValue,
      error: new ExcessUtil.ValueError(PURITY_RANGE_ERROR),
      locked: false,
    };
  }
  return {val: typedValue, error: null, locked: false};
}
